import { ReactNode } from 'react'
import { ApexOptions } from 'apexcharts'

/** Keeps ApexCharts inside card bounds (flex/grid min-width + SVG overflow). */
export function ChartFrame({ children }: { children: ReactNode }) {
  return (
    <div className='w-100 overflow-hidden' style={{ minWidth: 0, maxWidth: '100%' }}>
      <div className='dash-apex-frame' style={{ width: '100%', maxWidth: '100%' }}>
        {children}
      </div>
      <style>{`
        .dash-apex-frame,
        .dash-apex-frame > div,
        .dash-apex-frame .apexcharts-canvas {
          max-width: 100% !important;
          width: 100% !important;
        }
        .dash-apex-frame .apexcharts-svg {
          max-width: 100%;
        }
        .dash-apex-frame .apexcharts-legend {
          max-width: 100%;
          padding: 0 4px !important;
        }
        .dash-apex-frame .apexcharts-toolbar {
          max-width: 100%;
        }
      `}</style>
    </div>
  )
}

export const baseChart: ApexOptions['chart'] = {
  fontFamily: 'inherit',
  parentHeightOffset: 0,
  redrawOnParentResize: true,
  redrawOnWindowResize: true,
  animations: { enabled: false },
}

export const tightGrid: ApexOptions['grid'] = {
  padding: { left: 4, right: 8, top: 8, bottom: 0 },
}
